import React from 'react';
import {translate} from 'react-admin';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import LockIcon from '@material-ui/icons/Lock';
import compose from 'recompose/compose';

const styles = theme => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start',
        background: 'radial-gradient(circle, rgba(154,0,4,1) 0%, rgba(80,0,2,1) 100%)',
    },
    card: {
        minWidth: 300,
        marginTop: '6em',
        padding: '2em',
        textAlign: 'center',
        borderRadius: '15px',
        boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
        backdropFilter: 'blur( 4px )',
        border: '1px solid rgba( 255, 255, 255, 0.18 )',
    },
    icon: {
        fontSize: '5rem',
        color: '#9A0004',
        marginBottom: '0.5rem',
    },
    title: {
        fontWeight: 'bold',
        marginBottom: '1rem',
    },
    message: {
        color: '#666',
        marginBottom: '2rem',
    },
    button: {
        backgroundColor: '#9A0004',
        color: 'white',
        '&:hover': {
            backgroundColor: '#7a0003',
        },
    },
});

const UnauthorizedPage = (props) => {
    const {classes, translate} = props;

    return (
        <div className={classes.main}>
            <Card className={classes.card}>
                <LockIcon className={classes.icon}/>
                <Typography variant="h5" className={classes.title}>
                    Truy cập bị từ chối
                </Typography>
                <Typography variant="body1" className={classes.message}>
                    Hệ thống đã ngừng hỗ trợ đăng nhập trực tiếp. <br/>
                    Vui lòng truy cập thông qua liên kết từ đối tác của bạn.
                </Typography>
                <CardContent>
                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={() => window.location.href = '/'}
                    >
                        Quay lại trang chủ
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
};

export default compose(
    withStyles(styles),
    translate
)(UnauthorizedPage);
